import { ComponentType, lazy, LazyExoticComponent } from 'react'

import { retry } from './retry'
import { LoadFn } from './retryWithoutFallback'

export const lazyWithRetry = <TProps>(
  fn: LoadFn<TProps>,
  retriesLeft?: number,
  interval?: number,
): LazyExoticComponent<ComponentType<TProps>> =>
  lazy(() => retry(fn, retriesLeft, interval))
